
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 230 468","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 248.341v-1.275a9.42 9.42 0 01.583-2.63l50.9-139.406c4.852-13.278 19.992-23.54 33.926-23.54h58.776c13.934 0 29.083 10.263 33.322 23.54l51.504 139.407c1.215 4.825-1.215 9.658-5.454 11.468l-10.91 3.619c-4.842 1.809-9.694-.604-10.9-4.825l-41.81-113.465 33.934 135.186 10.9 38.625H158.28v144.24c0 4.826-4.249 8.453-8.488 8.453h-21.269c-4.851 0-8.487-3.627-8.487-8.452v-144.24h-10.768v144.24c0 4.825-3.636 8.452-8.488 8.452H79.511c-4.852 0-8.488-3.627-8.488-8.452v-144.24H24.22l44.834-173.812L27.847 254.7c-1.809 4.221-6.66 6.634-10.9 4.825l-11.512-4.222c-3.075-.875-5.193-3.657-5.435-6.96zM113.897 70.023c-19.388 0-35.149-15.69-35.149-35.007 0-19.308 15.76-34.998 35.149-34.998 19.388 0 35.14 15.69 35.14 34.998 0 19.317-15.752 35.007-35.14 35.007z"}})])
          )
        }
      }
    